module.exports = __webpack_public_path__ + "static/media/proveoppgave-3.1d0a698c.mp3";